import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../style/pages/real-estate-details.css";
import stickybits from "stickybits";
//@ts-ignore
import * as Pagination from "@wkWebSrc/js/components/pagination";
//@ts-ignore
import Gallery from "./vue/Gallery.vue";
//@ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import { useFavourite } from "@wkComposables/useFavourite";
//@ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
//@ts-ignore
import { observeOnce } from "@utils/ObserverUtils";
//@ts-ignore
import { EMAIL_REGEX_INTO_TEXT, COMPETITOR_REGEX, GLOBAL_PHONE_REGEX
//@ts-ignore
} from "@utils/RegexUtils";
import axios from "axios";
//@ts-ignore
import ContactAgencyBanner from "./vue/ContactAgencyBanner.vue";
import commonAsyncComponents from "./vue/CommonComponents/CommonModals";
//@ts-ignore
import { useSaveSearchModal } from "@wkComposables/useSaveSearchModal";
//@ts-ignore
import { SERVICE } from "@customTypes/ServiceEnum";
//@ts-ignore
import TrendBar from "./vue/TrendBar.vue";
//@ts-ignore
import { useShowPhone } from "@wkComposables/useShowPhone";
//@ts-ignore
import BaseTextarea from "./vue/UIKitComponents/BaseTextarea.vue";
//@ts-ignore
import { useContactAgencyModal } from "@wkComposables/useContactAgencyModal";
//@ts-ignore
import { useShareModal } from "@wkComposables/useShareModal";
//@ts-ignore
import BaseIcon from "@vueEntry/UIKitComponents/BaseIcon.vue";
//@ts-ignore
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import { useBaseSnackbar } from "@wkComposables/useBaseSnackbar";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import { useUtilities } from "@wkComposables/useUtilities";
import { createApp, defineAsyncComponent } from "vue";
//@ts-ignore
import SimilarREScrolling from "@vueEntry/SimilarREScrolling.vue";
//@ts-ignore
import { NotesIcon } from "@vueEntry/SvgIcons/NotesIcon";
//@ts-ignore
import { HeartIcon } from "@vueEntry/SvgIcons/HeartIcon";
//@ts-ignore
import { ShareIcon } from "@vueEntry/SvgIcons/ShareIcon";
//@ts-ignore
import { PhoneIcon } from "@vueEntry/SvgIcons/PhoneIcon";
//@ts-ignore
import { PrintIcon } from "@vueEntry/SvgIcons/PrintIcon";
//@ts-ignore
import { WarningIcon } from "@vueEntry/SvgIcons/WarningIcon";
//@ts-ignore
import { Modals } from "@customTypes/Modals";
//@ts-ignore
import BlogBanner from "@vueEntry/BlogBanner.vue";
import { mapState, mapActions, createPinia } from "pinia";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
import { useLoggedUserStore, usePublicUserMenuStore, useModalStore, useBaseStore, useMortgageStore, useMetadataStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import { handleInsertionClick } from "@wkWebSrc/js/components/insertion";
//@ts-ignore
import { handleBreadcrumbLinkClick } from "@wkWebSrc/js/components/navigationBreadcrumb";
//@ts-ignore
import { updateViewDetail } from "@services/statisticsAPI";
//@ts-ignore
import IntersectionObserverVue from "@vueEntry/IntersectionObserver/IntersectionObserverVue.vue";
//@ts-ignore
import IntersectionObservableVue from "@vueEntry/IntersectionObserver/IntersectionObservableVue.vue";
//@ts-ignore
import { formatInteger } from "@utils/NumberUtils";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useTrustpilotWidget } from "@wkComposables/useTrustpilotWidget";
//@ts-ignore
import ConsultantCard from "@vueEntry/ConsultantCard.vue";
//@ts-ignore
import CustodianSupervisorCard from "@vueEntry/CustodianSupervisorCard.vue";
var realEstateApp = createApp({
  name: "RealEstateDetails",
  components: Object.assign(Object.assign({
    NotesIcon,
    HeartIcon,
    ShareIcon,
    PhoneIcon,
    PrintIcon,
    WarningIcon,
    BaseBadge,
    Gallery,
    PublicUserMenu,
    BaseTextarea,
    BaseIcon,
    BaseButton,
    BaseInput,
    //@ts-ignore
    "mortgage-banner": defineAsyncComponent(() => import("@vueEntry/MortgageBanner.vue")),
    ContactAgencyBanner,
    TrendBar,
    SimilarREScrolling,
    BlogBanner,
    IntersectionObservableVue,
    IntersectionObserverVue,
    ConsultantCard,
    CustodianSupervisorCard,
    //@ts-ignore
    "share-modal": defineAsyncComponent(() => import("./vue/Modals/ShareModal.vue")),
    //@ts-ignore
    "report-issue-modal": defineAsyncComponent(() => import("./vue/Modals/ReportIssueModal.vue")),
    //@ts-ignore
    "save-search-modal": defineAsyncComponent(() => import("./vue/Modals/SaveSearchModal.vue")),
    //@ts-ignore
    "email-confirm-modal": defineAsyncComponent(() => import("./vue/Modals/EmailConfirmModal.vue")),
    //@ts-ignore
    "services-modal": defineAsyncComponent(() => import("@vmodals/Services/ServicesModal.vue")),
    //@ts-ignore
    "services-modal-success": defineAsyncComponent(() => import("@vmodals/Services/ServicesModalSuccess.vue")),
    //@ts-ignore
    "contact-agency-modal": defineAsyncComponent(() => import("./vue/Modals/ContactAgencyModal.vue")),
    //@ts-ignore
    "note-modal": defineAsyncComponent(() => import("./vue/Modals/NoteModal.vue")),
    //@ts-ignore
    "mail-alert-on-favourite-modal": defineAsyncComponent(() => import("./vue/Modals/MailAlertOnFavouriteModal.vue")),
    //@ts-ignore
    "base-bt-modal": defineAsyncComponent(() => import("@vueEntry/BaseBtModal.vue")),
    //@ts-ignore\
    "agency-alert-modal": defineAsyncComponent(() => import("./vue/Modals/AgencyAlertModal.vue")),
    //@ts-ignore
    "aira-modal": defineAsyncComponent(() => import("@vueEntry/Modals/Services/AiraModal.vue")),
    //@ts-ignore
    "auction-book-visit-banner": defineAsyncComponent(() => import("@vueEntry/AuctionBookVisitBanner.vue")),
    //@ts-ignore
    "switcho-banner": defineAsyncComponent(() => import("@vueEntry/SwitchoBanner.vue")),
    //@ts-ignore
    "countdown-comp": defineAsyncComponent(() => import("@vueEntry/CountdownComp.vue")),
    //@ts-ignore
    "auction-visit-modal": defineAsyncComponent(() => import("@vmodals/AuctionVisitModal.vue")),
    //@ts-ignore
    "request-attachments-modal": defineAsyncComponent(() => import("@vmodals/RequestAttachmentsModal.vue")),
    //@ts-ignore
    "consultant-phone-modal": defineAsyncComponent(() => import("@vmodals/ConsultantPhoneModal.vue")),
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseDropDown.vue"))
  }, LanguageIcons), commonAsyncComponents),
  setup() {
    var {
      displayPhone,
      phoneLabel,
      phoneViewId,
      showPhone
    } = useShowPhone();
    var {
      showBaseSnackbar,
      handleShowSnackbar,
      baseSnackbarProps
    } = useBaseSnackbar();
    var {
      isAppBannerVisible
    } = useAppBanner();
    var {
      isSmall,
      isLarge
    } = useBreakpoints();
    var {
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    } = useFirebaseMessaging();
    var {
      notes,
      disableNotes,
      focusNotes,
      notesInitialized,
      clearTextarea,
      handleAddFavorite,
      handleRemoveFavorite,
      openNoteModal,
      initNotes,
      editAndShowButtons,
      updateNote
    } = useFavourite();
    var {
      saveSearchModalIcons,
      saveSearchModalLabels,
      realEstateMiniItem,
      realEstateBean,
      ssmPlace
    } = useSaveSearchModal();
    var {
      agencyModalData,
      reopenAfterLogin,
      successModalDataEmitted,
      amdLabels,
      amdIcons,
      listingType,
      openContactModal,
      openAndReturnToCAMS
    } = useContactAgencyModal();
    var {
      shareModalData,
      openShareModal,
      gaEvent
    } = useShareModal();
    var {
      redirectTo
    } = useUtilities();
    useTrustpilotWidget();
    return {
      /* Used to exclude hover on mobile mode in svgIcons */
      isSmall,
      isLarge,
      displayPhone,
      phoneLabel,
      phoneViewId,
      showPhone,
      isAppBannerVisible,
      showBaseSnackbar,
      handleShowSnackbar,
      baseSnackbarProps,
      //Contact Agency Modal (CAM)
      //CAM state
      agencyModalData,
      reopenAfterLogin,
      successModalDataEmitted,
      //CAM computed
      amdLabels,
      amdIcons,
      listingType,
      //CAM methods
      openContactModal,
      openAndReturnToCAMS,
      //useFavourites states
      notes,
      disableNotes,
      focusNotes,
      notesInitialized,
      clearTextarea,
      //useFavourites methods
      handleAddFavorite,
      handleRemoveFavorite,
      openNoteModal,
      initNotes,
      editAndShowButtons,
      updateNote,
      //useFirebaseMessaging
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick,
      //useSaveSearchModal
      saveSearchModalIcons,
      saveSearchModalLabels,
      realEstateMiniItem,
      realEstateBean,
      ssmPlace,
      //useShareModal
      shareModalData,
      openShareModal,
      gaEvent,
      redirectTo
    };
  },
  data() {
    return {
      expandDescription: false,
      formSuccess: false,
      errorTracker: false,
      showServicesModal: false,
      // type of service
      serviceType: null,
      serviceMortgage: false,
      serviceAdsl: false,
      serviceGas: false,
      serviceLight: false,
      serviceLightGas: false,
      serviceNotChosen: false,
      showReportIssueModal: false,
      error_types: [],
      showSaveSearchModal: false,
      showMailConfirmModal: false,
      showValuationModal: false,
      /** flag used to control page reloading on a modal (see ValuationModal)*/
      activateReloadCb: false,
      trendPricesByPlace: {},
      trendDatasByPlace: {},
      place: {},
      isPrice: true,
      isSale: null,
      showAbitissimoWidget: false,
      showAbitissimoAfterMessage: false,
      // auction section
      countDown: {
        days: null,
        hours: null,
        minutes: null
      },
      auctionIsEnded: false,
      auctionRequestData: {
        name: null,
        surname: null,
        email: null,
        phone: null
      },
      consultantsList: [],
      consultantsListWithoutExtra: [],
      extraConsultant: null,
      fromListing: false,
      activeTabId: "",
      isRequestAttachmentsPhotos: null
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    serializedSearchBean() {
      return window["_serializedRealEstateBean"] || "";
    },
    enumService() {
      return SERVICE;
    },
    showContactModal() {
      return sessionStorage.getItem("contact") || "";
    },
    agencyID() {
      return window["_agencyId"];
    },
    agencyData() {
      return window["_agencyData"];
    },
    canonicalUrl() {
      return window["_canonicalURL"];
    },
    realEstateId() {
      return window["_referenceId"] || 0;
    },
    curPhoneLabel() {
      return window["_phoneLabel"];
    },
    isContractTypeSale() {
      return window["isSale"];
    },
    isREInFavorites() {
      return this.getFavoriteById(this.realEstateId) >= 0;
    },
    errorTypeList() {
      return window["errorTypes"];
    },
    randomConsultant() {
      return this.consultantsList.find(consultant => consultant.extra_flag === true) || this.consultantsList.find(consultant => consultant.top_flag === true) || this.consultantsList[Math.floor(Math.random() * this.consultantsList.length)];
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name", "email"])), mapState(useModalStore, ["showModal"])), mapState(useMortgageStore, ["installment"])), mapState(useMetadataStore, ["pageName"])),
  beforeCreate() {
    //Cleaning up any previous form values
    localStorage.removeItem("RIMFormValues");
  },
  created() {
    return __awaiter(this, void 0, void 0, function* () {
      // auction
      var serializedSb = JSON.parse(window["_serializedRealEstateBean"]);
      this.consultantsList = serializedSb.auctionConsultants;
      this.extraConsultant = serializedSb.auctionConsultants.find(consultant => {
        return consultant.extra_flag === true;
      });
      this.consultantsListWithoutExtra = serializedSb.auctionConsultants.filter(consultant => {
        return consultant.extra_flag !== true;
      });
      this.salePrice = Number(window["_priceSale"]);
      var success = yield this.initPublicUserMenu();
      this.setMortgageData(window["_priceSale"]);
      /* Used by ShowPhoneMixin */
      this.phoneLabel = this.curPhoneLabel;
      if (!this.realEstateId || !success) return;
      this.initNotes(this.realEstateId);
    });
  },
  mounted() {
    this.initPagination();
    this.initStickyDetails();
    this.fireAuctionCountDown();
    this.openFirstTab();
    //Initializing the description
    observeOnce("#description", (elem, observer) => {
      this.initDescription();
    });
    localStorage.removeItem("mortgageModalFormValues");
    var cityId = window._cityID;
    var zoneId = window._zoneID;
    this.isSale = window._sale;
    if (zoneId) this.getPlaceByZoneId(zoneId);else this.getPlaceByCityId(cityId);
  },
  methods: Object.assign(Object.assign(Object.assign(Object.assign({
    setAttachmentsAndOpenModal() {
      this.setShowModal(Modals.requestAttachmentsModal);
      this.isRequestAttachmentsPhotos = true;
    },
    openFirstTab() {
      var firstTab = document.querySelector("#poi-tab > li:nth-child(1) a");
      //In this case, there is no tab
      if (!firstTab) return;
      this.activeTabId = firstTab.getAttribute("id");
    },
    prevReDetails() {
      var pagination = Pagination.getPagination();
      pagination.idx = pagination.idx ? --pagination.idx % pagination.pageSize : -1;
      Pagination.writePagination(pagination);
    },
    nextReDetails() {
      var pagination = Pagination.getPagination();
      pagination.idx = pagination.idx ? ++pagination.idx % pagination.pageSize : -1;
      Pagination.writePagination(pagination);
    },
    formatInteger,
    handleBreadcrumbLinkClick,
    handleInsertionClick,
    handleHistoryBack() {
      history.back();
    },
    goToListing(e, url) {
      //Precondition: When we come from listing (desktop mode), the details page will be opened in a new tab
      if (this.fromListing) {
        e.preventDefault();
        //Closing the current tab -> as a side effect, we focus the tab we came from
        close();
        return;
      }
      location.href = url;
    },
    initPagination() {
      return __awaiter(this, void 0, void 0, function* () {
        var backUrlEl = document.querySelector(".backURL");
        backUrlEl === null || backUrlEl === void 0 ? void 0 : backUrlEl.setAttribute("href", window["_similarListingURL"]);
        yield Pagination.init();
        var pagination = Pagination.getPagination();
        //Setting the fromListing variable before it updates
        this.fromListing = pagination.fromListing;
        updateViewDetailStatistics(pagination);
        if (pagination === null || pagination === void 0 ? void 0 : pagination.fromMap) {
          backUrlEl === null || backUrlEl === void 0 ? void 0 : backUrlEl.addEventListener("click", e => {
            e.preventDefault();
            window.close();
          });
          var innerSpan = backUrlEl === null || backUrlEl === void 0 ? void 0 : backUrlEl.querySelector("span");
          if (innerSpan) innerSpan.innerText = window["_mapLabel"];
        }
      });
    },
    initStickyDetails() {
      if (window.screen.width > BREAKPOINT.MEDIUM) {
        stickybits("#detail-header", {
          useStickyClasses: true,
          stickyBitStickyOffset: 0
        });
      }
      if (window.screen.width < BREAKPOINT.SMALL) {
        var detailHeader = document.querySelectorAll("#detail-header");
        var detailSticky = document.querySelector("#detail-sticky");
        slideSticky(detailHeader, detailSticky, 0, "detail-sticky", false);
        var agencyContact = document.querySelectorAll("#agency-contact-box button");
        var agencyContactMobile = document.querySelector("#agency-contact-mobile");
        slideSticky(agencyContact, agencyContactMobile, 0, "w-0", true);
      }
    },
    handleShowMoreClick() {
      this.expandDescription = true;
      this.$refs.reDescription.classList.remove("description-collapsed");
    },
    initDescription() {
      var descriptionEl = this.$refs.reDescription;
      var text = descriptionEl.innerHTML;
      text = text.replace(EMAIL_REGEX_INTO_TEXT, "***");
      text = text.replace(COMPETITOR_REGEX, "***");
      text = text.replace(GLOBAL_PHONE_REGEX, "*********");
      descriptionEl.innerHTML = text;
      if (text.length < 350 && window.screen.width < BREAKPOINT.SMALL || text.length < 950 && window.screen.width >= BREAKPOINT.SMALL) {
        this.handleShowMoreClick();
      }
    },
    handleDesktopPhoneClick() {
      var _a;
      if (this.phoneViewId === 0) return;
      var showMessageStartTime = 19; // dalle 20
      var showMessageEndTime = 9; // alle 8
      var currentDate = new Date();
      var currentHour = currentDate.getHours();
      if (currentHour > showMessageStartTime || currentHour < showMessageEndTime) (_a = document.getElementById("alertBannerContainer")) === null || _a === void 0 ? void 0 : _a.classList.add("d-sm-block");
    },
    showAgencyAlertModal() {
      // open modal only if phone is already shown
      if (this.phoneViewId != 0) {
        setTimeout(() => {
          this.setShowModal(Modals.agencyAlertModal);
        }, 3000);
      }
    },
    redirectToAgencyDetails(url) {
      var isAgencyPremium = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!isAgencyPremium) return;
      window.location.href = url;
    },
    openModal() {
      var _a;
      (_a = document.getElementById("open-modal-contact")) === null || _a === void 0 ? void 0 : _a.click();
    },
    getOptions(key) {
      return window["_options"][key];
    },
    openServiceModal() {
      var serviceType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.showServicesModal = true;
      this.setShowModal(Modals.servicesModal);
      switch (serviceType) {
        case SERVICE.ADSL:
          this.serviceType = SERVICE.ADSL;
          this.serviceAdsl = true;
          break;
        case SERVICE.GAS:
          this.serviceType = SERVICE.GAS;
          this.serviceGas = true;
          break;
        case SERVICE.LIGHT:
          this.serviceType = SERVICE.LIGHT;
          this.serviceLight = true;
          break;
        case SERVICE.LIGHT_GAS:
          this.serviceType = SERVICE.LIGHT_GAS;
          this.serviceLightGas = true;
          break;
        case SERVICE.MORTGAGE:
          this.serviceType = SERVICE.MORTGAGE;
          this.serviceMortgage = true;
          break;
      }
    },
    resetServiceType() {
      this.showServicesModal = false;
      this.serviceMortgage = false;
      this.serviceAdsl = false;
      this.serviceLight = false;
      this.serviceGas = false;
      this.serviceLightGas = false;
      this.serviceNotChosen = false;
      this.setShowModal(Modals.noModal);
    },
    scrollToNote() {
      var _a;
      (_a = document.getElementById("image-main")) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
        behavior: "smooth"
      });
    },
    getPlaceByCityId(cityId) {
      axios.get("/rest/geography/placeByCityId/".concat(cityId)).then(response => {
        this.place = response.data;
        this.getTrendDatasByPlace(this.isSale);
      }).catch(e => {
        console.log("failed response due to: ", e.response);
      });
    },
    getPlaceByZoneId(zoneId) {
      axios.get("/rest/geography/placeByZoneId/".concat(zoneId)).then(response => {
        this.place = response.data;
        this.getTrendDatasByPlace(this.isSale);
      }).catch(e => {
        console.log("failed response due to: ", e.response);
      });
    },
    getTrendDatasByPlace(isSale) {
      axios.all([axios.post("/rest/statistics/getPlacePrices?sale=".concat(isSale), this.place), axios.post("/rest/statistics/getPlaceTrendData?sale=".concat(isSale), this.place)]).then(axios.spread((responsePrice, responseData) => {
        this.trendPricesByPlace = responsePrice.data;
        this.trendPricesByPlace.minPrice = parseInt(this.trendPricesByPlace.minPrice);
        this.trendPricesByPlace.maxPrice = parseInt(this.trendPricesByPlace.maxPrice);
        this.trendPricesByPlace.averagePrice = parseInt(this.trendPricesByPlace.averagePrice);
        this.trendPricesByPlace.minPrice = this.trendPricesByPlace.minPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.trendPricesByPlace.maxPrice = this.trendPricesByPlace.maxPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.trendPricesByPlace.averagePrice = this.trendPricesByPlace.averagePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.trendDatasByPlace = responseData.data;
      })).catch(e => {
        console.log("failed response due to: ", e.response);
      });
    },
    togglePriceRequest(price) {
      var priceLi = document.getElementById("price-li");
      var requestLi = document.getElementById("request-li");
      priceLi === null || priceLi === void 0 ? void 0 : priceLi.classList.remove("active");
      requestLi === null || requestLi === void 0 ? void 0 : requestLi.classList.remove("active");
      if (price) {
        this.isPrice = true;
        priceLi === null || priceLi === void 0 ? void 0 : priceLi.classList.add("active");
      } else {
        this.isPrice = false;
        requestLi === null || requestLi === void 0 ? void 0 : requestLi.classList.add("active");
      }
    },
    getFocusoutTextareaNote() {
      this.disableNotes = true;
      this.focusNotes = false;
    },
    fireAuctionCountDown() {
      var countDownInterval = setInterval(() => {
        var parsedSb = JSON.parse(window["_serializedRealEstateBean"]);
        var countDownDate = parsedSb.auctionDate;
        // const countDownDate = 1716156000000; // TODO WIKB2C-1256 solo per test countDown
        var now = new Date().getTime();
        var distance = countDownDate - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
        if (distance < 0) {
          clearInterval(countDownInterval);
          this.countDown = {
            days: 0,
            hours: 0,
            minutes: 0
          };
          this.auctionIsEnded = true;
          return;
        }
        this.countDown = {
          days: days,
          hours: hours,
          minutes: minutes
        };
      }, 1000);
    }
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(useBaseStore, ["initPublicUserMenu"])), mapActions(usePublicUserMenuStore, ["getFavoriteById"])), mapActions(useMortgageStore, ["setMortgageData"]))
});
realEstateApp.use(createPinia());
realEstateApp.mount("#re-details-main");
function slideSticky(target, element, ratio, cssClass, remove) {
  var observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > ratio) {
        remove ? element === null || element === void 0 ? void 0 : element.classList.add(cssClass) : element === null || element === void 0 ? void 0 : element.classList.remove(cssClass);
      } else {
        remove ? element === null || element === void 0 ? void 0 : element.classList.remove(cssClass) : element === null || element === void 0 ? void 0 : element.classList.add(cssClass);
      }
    });
  });
  target.forEach(item => {
    observer.observe(item);
  });
}
function updateViewDetailStatistics(pagination) {
  return __awaiter(this, void 0, void 0, function* () {
    if (window["_bot"]) return;
    var data = {
      agencyId: window["_agencyId"],
      realEstateId: window["_referenceId"] || 0
    };
    if (pagination === null || pagination === void 0 ? void 0 : pagination.fromListing) {
      data.fromListing = true;
      pagination.fromListing = false;
      Pagination.writePagination(pagination);
    } else data.fromListing = false;
    yield updateViewDetail(data);
  });
}